module.exports = __webpack_public_path__ + "static/media/fivek-es.6cd1098d.png";